import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Meta } from '@angular/platform-browser';
import { ActivatedRouteSnapshot, CanActivate, RouterStateSnapshot, UrlTree } from '@angular/router';
import { Store } from '@ngrx/store';
import { WindowRef } from '@shared/services';
import { environment } from '@src/environments';
import { ClearStateAndStorage } from '@store/actions';
import { selectVgClientPoid } from '@store/selectors/client-accounts/client-accounts.selectors';
import { Observable, of } from 'rxjs';
import { catchError, map, withLatestFrom } from 'rxjs/operators';

import { overviewRedirect } from '../launch/launch.guard';

@Injectable({
  providedIn: 'root',
})
export class AuthGuard implements CanActivate {
  constructor(
    private http: HttpClient,
    private meta: Meta,
    private windowRef: WindowRef,
    private store: Store,
  ) {}

  canActivate(
    _: ActivatedRouteSnapshot,
    state: RouterStateSnapshot,
  ): Observable<boolean | UrlTree> | Promise<boolean | UrlTree> | boolean | UrlTree {
    return this.http
      .post<{
        poid: string;
        sPoid: string;
      }>(`secure/auth`, {}, { withCredentials: true })
      .pipe(
        withLatestFrom(this.store.select(selectVgClientPoid)),
        map(([data, poid]) => {
          if (!!poid && poid !== data.poid) {
            this.store.dispatch(ClearStateAndStorage());
            this.windowRef.nativeWindow.location.href = `${environment.applicationUrl}/${overviewRedirect(state.url)}`;
            return false;
          }
          this.meta.updateTag({ name: 'DCSext.poid', content: data.poid });
          // Medallia needz dis
          this.windowRef.nativeWindow.spoid = data.sPoid;

          return true;
        }),
        catchError(() => {
          // Redirect to logon if they are not authenticated, set target back to the current page once they logged in
          const targetOverride = `${environment.applicationUrl}${state.url}`;
          this.windowRef.nativeWindow.location.href = `${environment.logonUrl}?TARGET_OVERRIDE=${targetOverride}`;
          return of(false);
        }),
      );
  }
}
